import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { EditTaskDocumentComponent } from "./edit-task-document/edit-task-document.component";
import { AddTaskDocumentComponent } from "./add-task-document/add-task-document.component";
import { TaskDocument } from "../core/model/task-document";
import { TaskDocumentService } from "../core/service/task-document.service";

@Component({
  selector: "app-task-document",
  templateUrl: "./task-document.component.html",
  styleUrls: ["./task-document.component.scss"],
})
export class TaskDocumentComponent implements OnInit {
  documents: TaskDocument[];
  taskId: number;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _taskDocumentService: TaskDocumentService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.taskId = params["taskId"];
      this.getTaskDocumentsByTaskworkflowId(this.taskId);
    });
  }

  getTaskDocumentsByTaskworkflowId(taskid) {
    this._taskDocumentService
      .getTaskDocumentsByTaskworkflowId(taskid)
      .subscribe(
        (data) => {
          this.documents = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  edit(taskDocument: TaskDocument): void {
    const modalRef = this.modalService.open(EditTaskDocumentComponent, {
      centered: true,
    });
    modalRef.componentInstance.taskDocument = taskDocument;

    modalRef.result.then(
      (updated: TaskDocument) => {
        if (updated && this.documents) {
          const index = this.documents.findIndex((d) => d.id === updated.id);
          if (index !== -1) {
            this.documents[index] = updated;
            this.documents = [...this.documents];
            return;
          }
        }
        this.getTaskDocumentsByTaskworkflowId(this.taskId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddTaskDocumentComponent, {
      centered: true,
    });
    // Contexte filtre (pas l'entité éditée)
    modalRef.componentInstance.taskworkflowId = this.taskId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getTaskDocumentsByTaskworkflowId(this.taskId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  delete(taskDocumentId) {
    this._taskDocumentService.delete(taskDocumentId).subscribe(
      (data) => {
        this.getTaskDocumentsByTaskworkflowId(this.taskId);
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
